import React from 'react';
import { useSelector } from 'react-redux';
import { Icon, Popup, Header } from 'semantic-ui-react';

const Editors = ({ expandSidebar }) => {
  const [email, editors] = useSelector((state) => [
    state.mainFrame.email,
    state.mainFrame.editors,
  ]);

  //   const sortedEditors = [...editors].sort();
  const sortedEditors = editors.filter((editor) => editor !== email).sort();

  if (sortedEditors.length === 0) {
    return null;
  }

  let style;
  if (expandSidebar) {
    style = {
      position: 'absolute',
      top: '10px',
      right: '6px',
      zIndex: 10,
    };
  } else {
    style = {
      display: 'flex',
      justifyContent: 'center',
      marginTop: '4px',
      marginBottom: '4px',
    };
  }

  return (
    <div style={style}>
      <Popup
        content={
          <div>
            <Header as="h4" dividing>
              Currently Online
            </Header>
            <div
              style={{ display: 'flex', flexDirection: 'column', gap: '0.5em' }}
            >
              {sortedEditors.map((editor) => {
                return <div key={editor}>{editor}</div>;
              })}
            </div>
          </div>
        }
        trigger={
          <Icon
            name="user circle"
            color="blue"
            size="large"
            title="Other users currently editing this project"
          />
        }
      />
    </div>
  );
};

export default Editors;
